import { Reveal, MaskLines } from "@/components/Reveal";

const frames = [
  { label: "Homepage", route: "/" },
  { label: "Menu Experience", route: "/menu" },
  { label: "Private Dining", route: "/private-dining" },
];

const MobilePage = () => (
  <main data-testid="mobile-page" className="bg-[#0a0908]">
    <section className="pt-36 pb-16 text-center px-6 grain relative">
      <p className="text-[10px] tracking-[0.45em] uppercase text-[#C1272D] mb-6">Mobile-First by Design</p>
      <h1 className="font-serif text-white font-light text-4xl sm:text-5xl md:text-6xl leading-none">
        <MaskLines lines={["The Mobile Experience"]} delay={0.3} />
      </h1>
      <p className="text-white/50 font-light mt-6 max-w-xl mx-auto leading-relaxed">
        Every screen is designed mobile-first — no PDFs, no pinch-to-zoom. A persistent, unobtrusive Reserve button keeps conversion one tap away.
      </p>
    </section>

    <section className="pb-32 px-6">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-3 gap-12 md:gap-8 place-items-center">
        {frames.map((f, i) => (
          <Reveal key={f.route} delay={i * 0.12}>
            <div className="flex flex-col items-center">
              {/* Phone frame */}
              <div className="relative w-[300px] h-[620px] rounded-[2.5rem] border-[10px] border-[#1a1817] bg-[#0a0908] shadow-2xl overflow-hidden" data-testid={`phone-frame-${i}`}>
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-[#1a1817] rounded-b-2xl z-20" />
                <iframe
                  title={f.label}
                  src={f.route}
                  className="w-[375px] h-[812px] origin-top-left scale-[0.746] border-0"
                  loading="lazy"
                />
              </div>
              <p className="font-serif text-2xl text-white mt-6">{f.label}</p>
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#C1272D] mt-1">Live · Scaled preview</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </main>
);

export default MobilePage;
